export default "__VITE_ASSET__D8NqnXSm__"